import jwt_decode from 'jwt-decode';
import { CUSTOMER_ROLES } from '../constants/roles';
import { Routes } from '../constants/routes';

/**
 * ALWYAS interrogate the user's current access token to check if they're still
 * logged in, because it could have expired or been modified.  Do not store a
 * snapshot of a user's loggedIn status in Redux, because it can become out of
 * date and thus inaccurate.
 * 
 * @param {*} reduxUser 
 */
export const isLoggedIn = (reduxUser) => {
    if (reduxUser && reduxUser.accessToken) {
        const jwt = jwt_decode(reduxUser.accessToken);
        if (!jwt) { 
            return false;
        }

        const current_time = Date.now().valueOf() / 1000;
        const isExpired = (jwt && jwt.exp && jwt.exp < current_time);
        const isBeforeTokenIssuanceTime = (jwt && jwt.nbf && jwt.nbf >= current_time);
    
        if (isExpired && isBeforeTokenIssuanceTime) {
            return false;
        }

        return true;
    }
    return false;
}

export const getTokenExp = (reduxUser) => {
    if(reduxUser && reduxUser.accessToken) {
        const jwt = jwt_decode(reduxUser.accessToken);
        if (!jwt) { 
            return 0;
        }
        return jwt.exp;
    } else {
        return 0;
    }
}

export const getRedirectLocation = (customerRoleName, hasMultipleLocations) => {
    if(customerRoleName === CUSTOMER_ROLES.User.name || !hasMultipleLocations){
        return Routes.DashboardLocation;
    } else {
        return Routes.DashboardCorporate;
    }
}